<app-spinner [isLoading]="isLoading$ | async">
  <div
    class="container"
    *ngIf="{
      year: workExperienceYears$ | async,
      month: workExperienceMonth$ | async,
      cvExportLoading: cvExportLoading$ | async,
      jobseekerWorkExperiences: jobseekerWorkExperiences$ | async,
      jobseekerPersonalInfo: jobseekerPersonalInfo$ | async,
      jobseekerEducations: jobseekerEducations$ | async,
      documents: documents$ | async,
      documentInMod: documentInMod$ | async,
      educationMaxLevel: educationMaxLevel$ | async,
      languagesInMod: languagesInMod$ | async,
      jobseekerLanguages: jobseekerLanguages$ | async,
      jobseekerHardSkills: jobseekerHardSkills$ | async,
      jobseekerSoftSkills: jobseekerSoftSkills$ | async,
      timeZone: timeZone$ | async,
      photoIsInModeration: photoIsInModeration$ | async,
      jobseekerNewExperiences: jobseekerPendingExperiences$ | async,
      jobseekerPendingExperiences: jobseekerNewExperiences$ | async,
      documentTypeMap: documentTypeMap$ | async,
      currentUserType: currentUserType$ | async,
      currentLanguage: currentLanguage$ | async,
      isWorkExperienceFilledInModeration:
        isWorkExperienceFilledInModeration$ | async,
      hardSkillsInModeration: hardSkillsInModeration$ | async,
      softSkillsInModeration: softSkillsInModeration$ | async
    } as data"
  >
    <div *ngIf="jobseeker$ | async as jobseeker">
      <div class="head-info">
        <div *ngIf="jobseeker.lacksNecessaryInformation" class="lack-info">
          <div class="lack-info-icon">
            <svg-icon
              class="lack-info-icon__warning"
              src="/assets/icons/warning.svg"
            ></svg-icon>
          </div>
          <div class="lack-info-text">
            <span class="lack-info-text__message">{{
              'message.JobseekerProfileLacksNecessaryInformation' | translate
            }}</span>
            <span
              class="lack-info-text__message-item"
              *ngFor="
                let lackItem of jobseeker.lackedFieldList;
                let last = last
              "
            >
              {{ necessaryFieldMap[lackItem] | translate
              }}{{ last ? '' : '; ' }}
            </span>
          </div>
        </div>
        <button
          [disabled]="data.cvExportLoading"
          (click)="onCvExport()"
          class="save-profile-btn"
        >
          <div class="save-profile-btn__text">
            {{ 'label.SaveProfileAsPdf' | translate }}
          </div>
        </button>
      </div>
      <mat-progress-bar
        *ngIf="data.cvExportLoading"
        mode="indeterminate"
      ></mat-progress-bar>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [hasOutOfTileContent]="true"
      >
        <hrra-jobseeker-personal-info
          tile-content
          [userType]="data.currentUserType"
          [timeZone]="data.timeZone"
          [currentLang]="data.currentLanguage"
          [personalInfo]="jobseekerPersonalInfo$ | async"
          (onEditPersonalInfo)="editPersonalInfo()"
          class="main-content"
        ></hrra-jobseeker-personal-info>
        <hrra-jobseeker-photo
          [userType]="data.currentUserType"
          out-of-tile-content
          [photoHref]="jobseeker.photoHref"
          [photoIsInModeration]="data.photoIsInModeration"
          (onEditPhoto)="editPhoto($event, jobseeker.photoHref)"
          (onDeletPhoto)="deletePhoto(jobseeker.moderationLastChangeDate)"
          class="photo-content"
        ></hrra-jobseeker-photo>
      </hrra-jobseeker-profile-tile>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [title]="'label.WorkExperience' | translate"
        [rightText]="
          ('label.Year' | translate: { count: data.year }) +
          ' ' +
          ('label.Month' | translate: { count: data.month })
        "
      >
        <div tile-content>
          <div *ngIf="data.jobseekerWorkExperiences?.length > 0">
            <div
              *ngFor="let workExperience of data.jobseekerWorkExperiences"
              class="main-content"
            >
              <hrra-jobseeker-work-experience
                [userType]="data.currentUserType"
                [workExperience]="workExperience"
                [isInModeration]="isExperienceInModeration(data.jobseekerNewExperiences, data.jobseekerPendingExperiences, workExperience.experienceId)"
                [timeZone]="data.timeZone"
                [currentLang]="data.currentLanguage"
                (onEditExperience)="editWorkExperience($event)"
                (onDeletExperience)="
                  deleteExperience($event, jobseeker.moderationLastChangeDate)
                "
                (onDownloadExperienceAttachment)="
                  downloadExperienceAttachment($event)
                "
              ></hrra-jobseeker-work-experience>
            </div>
          </div>
          <div
            *ngIf="
              data.jobseekerWorkExperiences?.length == 0 &&
              jobseeker.isWorkExperienceFilled
            "
            class="without-experience-text"
          >
            <app-icon
              *ngIf="data.isWorkExperienceFilledInModeration"
              [tooltipText]="'label.IsInModeration' | translate"
              [iconButtonType]="iconButtonType.moderation"
              class="mod-icon"
            ></app-icon>
            {{ 'label.WithoutExperience' | translate }}
          </div>
        </div>

        <button
          *ngIf="!jobseeker.isWorkExperienceFilled"
          button
          class="without-experience-button"
          (click)="onIsWorkExperienceFilled(jobseeker.moderationLastChangeDate)"
        >
          {{ 'label.WithoutExperience' | translate }}
        </button>
        <button
          (click)="onWorkExperienceCreate()"
          class="new-green-button"
          new-add-button
        >
          {{ 'label.AddWithPlus' | translate }}
        </button>
      </hrra-jobseeker-profile-tile>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [title]="'label.Education' | translate"
        [rightText]="data.educationMaxLevel"
      >
        <div
          tile-content
          *ngFor="let education of data.jobseekerEducations"
          class="main-content"
        >
          <hrra-jobseeker-education
            [userType]="data.currentUserType"
            [education]="education"
            [timeZone]="data.timeZone"
            [currentLang]="data.currentLanguage"
            (onEditEducation)="editEducation($event)"
            (onDeletEducation)="
              deleteEducation($event, jobseeker.moderationLastChangeDate)
            "
            (onDownloadEducationAttachment)="
              downloadEducationAttachment($event)
            "
          ></hrra-jobseeker-education>
        </div>
        <button
          (click)="onEducationCreate()"
          class="new-green-button"
          new-add-button
        >
          {{ 'label.AddWithPlus' | translate }}
        </button>
      </hrra-jobseeker-profile-tile>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [title]="'label.Skills' | translate"
      >
        <div tile-content class="main-content">
          <div class="hard-skills">
            <div class="hard-skill-actions">
               <div class="header-icon-container">
                <span class="skills-header">{{'label.HardSkills' | translate}}</span>
                @if (data.hardSkillsInModeration) {
                  <svg-icon svgClass="moderation-icon" src="assets/icons/new-moderation.svg" [matTooltip]="'label.IsInModeration' | translate"></svg-icon>
                }
               </div>
               @if (data.jobseekerHardSkills?.length) {
                 <app-icon-button
                   (click)="onSkillsEdit(skillBase.Hard)"
                   [iconButtonType]="iconButtonType.editNew"
                 ></app-icon-button>
               } @else {
                 <button
                 (click)="onSkillsEdit(skillBase.Hard)"
                 class="new-green-button"
                 new-add-button
                 >
                   {{ 'label.AddWithPlus' | translate }}
                 </button>
               }
            </div>

          <hrra-skills
             [skills]="data.jobseekerHardSkills ?? []"
             [userType]="data.currentUserType"
             [editable]="false"
           ></hrra-skills>
          </div>

          <div class="soft-skills">
            <div class="soft-skill-actions">
              <div class="header-icon-container">
                <span class="skills-header">{{'label.SoftSkills' | translate}}</span>
                @if (data.softSkillsInModeration) {
                  <svg-icon svgClass="moderation-icon" src="assets/icons/new-moderation.svg" [matTooltip]="'label.IsInModeration' | translate"></svg-icon>
                }
              </div>
              @if (data.jobseekerSoftSkills?.length) {
                <app-icon-button
                  (click)="onSkillsEdit(skillBase.Soft)"
                  [iconButtonType]="iconButtonType.editNew"
                ></app-icon-button>
              } @else {
                <button
                  (click)="onSkillsEdit(skillBase.Soft)"
                  class="new-green-button"
                  new-add-button
                >
                  {{ 'label.AddWithPlus' | translate }}
                </button>
              }
            </div>

            <hrra-skills
              [skills]="data.jobseekerSoftSkills ?? []"
              [userType]="data.currentUserType"
              [editable]="false"
            ></hrra-skills>

          </div>

        </div>
      </hrra-jobseeker-profile-tile>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [title]="'label.Languages' | translate"
      >
        <div
          tile-content
          *ngFor="let language of data.jobseekerLanguages"
          class="main-content main-content--language"
        >
          <hrra-jobseeker-language
            [userType]="data.currentUserType"
            [language]="language"
            [languageIsInMod]="
              data.languagesInMod[language.jobseekerLanguageId]
            "
            (onEditLanguage)="editLanguage($event)"
            (onDeleteLanguage)="
              deleteLanguage($event, jobseeker.moderationLastChangeDate)
            "
            (onDownloadLanguageAttachment)="downloadLanguageAttachment($event)"
          ></hrra-jobseeker-language>
        </div>
        <button
          (click)="onLanguageCreate()"
          class="new-green-button"
          new-add-button
        >
          {{ 'label.AddWithPlus' | translate }}
        </button>
        <!-- <app-advanced-button (click)="onLanguageCreate()" add-button [iconType]="iconButtonType.add" [text]="'label.Add' | translate" [type]="'uncoloured-blue'" class="add-button"></app-advanced-button> -->
      </hrra-jobseeker-profile-tile>

      <hrra-jobseeker-profile-tile
        [userType]="data.currentUserType"
        [title]="'label.Documents' | translate"
      >
        <div
          tile-content
          *ngFor="let document of data.documents"
          class="main-content"
        >
          <hrra-jobseeker-document
            [userType]="data.currentUserType"
            [document]="document"
            [documentTypeMap]="data.documentTypeMap"
            (onDeletDocument)="
              deleteDocument($event, jobseeker.moderationLastChangeDate)
            "
            [documentIsInMod]="data.documentInMod[document.jobseekerDocumentId]"
            (onDownloadDocment)="downloadDocument($event)"
          ></hrra-jobseeker-document>
        </div>
        <button
          (click)="onDocumentCreate()"
          class="new-green-button"
          new-add-button
        >
          {{ 'label.UploadAttachment' | translate }}
        </button>
        <!-- <app-advanced-button (click)="onDocumentCreate()" add-button [iconType]="iconButtonType.add" [text]="'label.UploadDocuments' | translate" [type]="'uncoloured-blue'" class="add-button"></app-advanced-button> -->
      </hrra-jobseeker-profile-tile>
    </div>
  </div>
</app-spinner>
